import React from 'react'
import Icon, { IconType } from '../../Icon'
import Col from '../../Col'
import Row from '../../Row'
import fileSize from '@bt-react/libs/fileSize'
import { AttachmentsListItemProps } from './../types'
import styles from '@bt-react/styles'
import componentStyles from './AttachmentsListItem.module.scss'
import classNames from 'classnames'
import { useDrag, useDrop } from 'react-dnd'
import { useIsNarrowView } from '../../Attachments/Attachments'

const AttachmentsListItem: React.FC<AttachmentsListItemProps> = ({status, data, readonly, setView, selectAttachment, moveList, findList, isCentral}) => {

    const {file, link, isCancelled} = data

    const originalIndex = findList(data.id).index

    const [{ isDragging }, drag, preview] = useDrag({
        item: { type: 'lists', id:data.id, data, originalIndex },
        collect: (monitor) => ({
        isDragging: monitor.isDragging(),
        }),
        end: (dropResult, monitor) => {
        const { id: droppedId, originalIndex } = monitor.getItem()
        const didDrop = monitor.didDrop()
        if (!didDrop) {
            moveList(droppedId, originalIndex)
        }
        },
    })
    
    const [, drop] = useDrop({
        accept: 'lists',
        canDrop: () => false,
        hover({ id: draggedId }: any) {
        if (draggedId !== data.id) {
            const { index: overIndex } = findList(data.id)
            moveList(draggedId, overIndex)
        }
        },
    })
    
    const opacity = isDragging ? 0 : 1

    const isNarrowView = useIsNarrowView()

    return (
        <div className={componentStyles['attachments-item-container']} data-bdd="attachments-list-item" ref={preview} style={{ opacity }}>
            <Row>
                <Col xs={8} className={componentStyles['attachment-wrapper']}>
                    <Icon name={file ? IconType.iconName.file : IconType.iconName.link} className={componentStyles['attachment-icon']} />
                    <div className={componentStyles["mb"]} data-bdd="attachment-title">
                        {link && <a href={link.href} className={classNames(componentStyles['title-link'], {[componentStyles['title-link-focus']]: isCentral})} target="_blank" rel="noreferrer">
                            {data.title}
                        </a>}
                        {!link && file &&
                            <a href={file.href} target='_blank' className={classNames(componentStyles['title-link'], {[componentStyles['title-link-focus']]: isCentral})} download rel="noreferrer">
                                {data.title}
                            </a>
                        }
                    </div>
                </Col>
                {file &&
                    <Col xs={4} >
                        <span data-bdd="attachment-file-size" className={componentStyles['file-size']}>{file.size ? fileSize(file.size, true) : ''}</span>
                    </Col>
                }
            </Row>
            <Row className={styles['pt-3']}>
                {link &&
                    <Col xs={isNarrowView ? 12 : 8}>
                        <a className={classNames({[componentStyles['attachment-link-narrow']]: isNarrowView, [componentStyles['attachment-link-narrow-focus']]: isCentral})} data-bdd="attachment-link" href={link.href} target="_blank" rel="noreferrer">{link.href}</a>
                    </Col>
                }
                {file && !file.href && !isCancelled &&
                    <Col xs={8}>
                        <Icon name={IconType.iconName.spinner} className={componentStyles['spinner-icon']} dataBdd="attachment-processing-spinner" />
                        Processing file...
                    </Col>
                }
                {!readonly &&
                    <Col xs={{ size: isNarrowView ? 12 : 4, offset: (isNarrowView || link || (file && !file.href && !isCancelled)) ? 0 : 8 }} className={componentStyles['action-icons']}>
                        <span onClick={()=>{
                            setView('add')
                            selectAttachment(data)                        
                        }}>
                            <Icon dataBdd="attachment-edit-icon" name={isCentral ? IconType.iconName.pencilRegular : IconType.iconName.pencil} className={componentStyles['action-icon']}/>
                        </span>
                        <span onClick={()=>{
                            setView('delete')
                            selectAttachment(data)                         
                        }}>
                            <Icon dataBdd="attachment-trash-icon" name={isCentral ? IconType.iconName.trashRegular : IconType.iconName.trash} className={componentStyles['action-icon']}/>
                        </span>
                        {!status.isProcessing &&
                            <span ref={(node) => drag(drop(node))}>
                                <Icon dataBdd="attachment-bars-icon" name={IconType.iconName.bars} className={classNames(componentStyles['action-icon'], 'handle-bar', componentStyles['burger-icon'])}/>
                            </span>
                        }
                    </Col>
                }
            </Row>
        </div>
    )

}

export default AttachmentsListItem